<div class="container container-image container-size">
  <a href="https://www.ktbl.de">
    <img src="assets/img/Logo_KTBL.png" alt="ktbl" class="img" />
  </a>

<img
  style="float: right"
  src="assets/img/Logo_Natimon.png"
  alt="natimon"
  class="img2"
/>
</div>
